export default {
  picture: null,
  isPictureLoading: false,
  isPictureError: false,
  pictureResult: false,
  pictureErrorMessage: ''
};
